/*
 * @Author: LGY 18588437913@163.com
 * @Date: 2022-08-01 16:01:00
 * @LastEditors: LGY 18588437913@163.com
 * @LastEditTime: 2023-02-20 12:00:40
 * @FilePath: /zxxbm-mobile/src/utils/common.js
 */
/**
 * 仅对jpeg格式图片压缩
 * @param file Type: File or Blob
 * @param quality 图片压缩比 0-1,数字越小，图片压缩越小
 */
import Compressor from "compressorjs";
export function CompressorImg(file, quality) {
  return new Promise((resolve, reject) => {
    new Compressor(file, {
      quality: quality || 0.8,
      success(result) {
        // const formData = new FormData();
        // let file = new File([result], _file.name, { type: _file.type })
        // formData.append('file', _file.name, {type:_file.type});
        resolve(result);
      },
      error(err) {
        reject(result);
        console.log(err.message);
      },
    });
  });
}
/**
 * 将非jpeg文件转成jpeg文件
 */
export function ConvertImage(file) {
  return new Promise((resolve, reject) => {
    const fileName = file.name.substring(0, file.name.indexOf("."));
    let reader = new FileReader(); //读取file
    reader.readAsDataURL(file);
    reader.onloadend = function (e) {
      let image = new Image(); //新建一个img标签（还没嵌入DOM节点)
      image.src = e.target.result; //将图片的路径设成file路径
      image.onload = function () {
        let canvas = document.createElement("canvas"),
          context = canvas.getContext("2d"),
          imageWidth = image.width,
          imageHeight = image.height,
          data = "";
        canvas.width = imageWidth;
        canvas.height = imageHeight;

        context.drawImage(image, 0, 0, imageWidth, imageHeight);
        data = canvas.toDataURL("image/jpeg");
        var newfile = dataURLtoFile(data, fileName + ".jpeg");
        console.log("new", newfile);
        resolve(newfile);
      };
    };
  });
}
function dataURLtoFile(dataurl, filename) {
  // base64转file对象
  let arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime }); //转成了jpeg格式
}
